import { type ElementType } from "react";
import { type SxProps, type Theme } from "@mui/material/styles";

import { Box } from "ui/box";

interface LogoProps {
  height?: string;
  width?: string;
  isClientUser?: boolean;
  useWhiteBgVersion?: boolean;
  testid?: string;
  component?: ElementType;
  className?: string;
  sx?: SxProps<Theme>;
}

export const Logo = ({
  height = "24px",
  width = "128px",
  isClientUser,
  useWhiteBgVersion = false,
  testid = "logo",
  component = "div",
  className,
  sx,
}: LogoProps) => {
  const logoSrc = isClientUser
    ? useWhiteBgVersion
      ? "/logo-two-ocean-onwhite.svg"
      : "/logo-two-ocean.svg"
    : useWhiteBgVersion
      ? "/logo-apollo-onwhite.svg"
      : "/logo-apollo.svg";

  return (
    <Box component={component} data-testid={testid} className={className} sx={sx}>
      <Box
        component="img"
        alt="logo"
        src={logoSrc}
        sx={{ height, width, objectFit: "contain", objectPosition: "left" }}
      />
    </Box>
  );
};
